import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FileText } from 'lucide-react';
import { UploadCard } from '../../../components/common/uploads';
/**
 * Main UploadGallery Component
 */
export const UploadGallery = ({ uploads, pendingUploads, onDelete, onAddTag, onRemoveTag, onImageClick, }) => {
    // Combine and sort all uploads (pending first, then by date descending)
    const allItems = [
        ...pendingUploads.map((p) => ({ ...p, _isPending: true })),
        ...uploads.map((u) => ({ ...u, _isPending: false })),
    ].sort((a, b) => {
        // Pending uploads first
        if (a._isPending && !b._isPending)
            return -1;
        if (!a._isPending && b._isPending)
            return 1;
        // Then by lastModified descending
        const aTime = a.lastModified || 0;
        const bTime = b.lastModified || 0;
        return bTime - aTime;
    });
    if (allItems.length === 0) {
        return (_jsxs("div", { className: "flex flex-col items-center justify-center py-12 text-muted-foreground", children: [_jsx(FileText, { className: "h-12 w-12 mb-4 opacity-50" }), _jsx("p", { className: "text-lg font-medium", children: "No uploads yet" }), _jsx("p", { className: "text-sm mt-1", children: "Use the camera or upload buttons above to add photos" })] }));
    }
    return (_jsx("div", { className: "grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6", children: allItems.map((item) => {
            const isPending = item._isPending;
            const upload = item;
            const hasId = 'id' in upload && upload.id;
            return (_jsx(UploadCard, { upload: upload, variant: "gallery", isPending: isPending, showTags: true, showCopyButtons: true, onImageClick: hasId && onImageClick ? () => onImageClick(upload) : undefined, onDelete: hasId ? async () => {
                    if (!window.confirm(`Are you sure you want to delete ${upload.filename}?`))
                        return;
                    await onDelete(upload.id);
                } : undefined, onAddTag: hasId ? async (tag) => { await onAddTag(upload.id, tag); } : undefined, onRemoveTag: hasId ? async (tag) => { await onRemoveTag(upload.id, tag); } : undefined }, isPending ? `pending-${item.filename}` : `upload-${item.id}`));
        }) }));
};
export default UploadGallery;
